export enum SourcePage {
  workspace = 'workspace',
  homePage = 'homepage',
  quickGuide = 'quick_guide',
  actionItems = 'action_items',
  teamPage = 'team_page',
  goalDetailPage = 'goal_detail_page',
  reviewDetailPage = 'review_detail_page',
  meetingMode = 'meeting_mode',
  settingsUserManagement = 'settings_user_management',
  integrationsPage = 'integrations_page',
}
